import React from 'react';
import { BasicInput, FieldInputProps } from './BasicInput';

function fromDate(date: Date): string {
  const yyyy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const dd = date.getDate().toString().padStart(2, '0');
  const hh = date.getHours().toString().padStart(2, '0');
  const min = date.getMinutes().toString().padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

function toDate(dateStr: string): Date {
  return new Date(dateStr);
}

export const DateInput = ({
  value,
  onChange,
  ...rest
}: FieldInputProps<Date>): JSX.Element => {
  const handleDateChange = (fieldValue: string) => {
    if (onChange) {
      onChange(toDate(fieldValue));
    }
  };
  const currentDate = new Date();
  const minDateTime = fromDate(currentDate);

  return (
    <BasicInput
      inputType="datetime-local"
      value={value ? fromDate(value) : undefined}
      onChange={handleDateChange}
      inputProps={{ min: minDateTime }}
      {...rest}
    />
  );
};
